import frecce from "../images/frecce.png"

function PreRegister({
  preUsername, prePassword, setPreUsername, setPrePassword, onSubmit
}) {
  return (
    <div className={`d-flex align-items-center justify-content-center `}>
      <main className="form-signin w-100 m-auto" style={{ maxWidth: "330px" }}>

        <form onSubmit={onSubmit}>
          <img
            className="w-100"
            src= {frecce}
            alt=""
            width="50"
            height="150"
          />
          <h1 className="h3 mb-3 fw-normal text-center" style={{ color: "white" }}> Immetti le credenziali predefinite:</h1>

          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              id="floatingInput"
              placeholder="username"
              value={preUsername}
              onChange={(e) => setPreUsername(e.target.value)}
              required
            />
            <label htmlFor="floatingInput">Username</label>
          </div>

          <div className="form-floating mb-4">
            <input
              type="password"
              className="form-control"
              id="floatingPassword"
              placeholder="Password"
              value={prePassword}
              onChange={(e) => setPrePassword(e.target.value)}
              required
            />
            <label htmlFor="floatingPassword">Password</label>
          </div>


          <button className="btn btn-primary w-100 py-2" type="submit">
            Prosegui
          </button>
          
        </form>
      </main>
    </div>
  );
}

export default PreRegister;
